import React from 'react';
import PropTypes from 'prop-types';
import {Icon} from '@/components/atoms';

const WarningLabel = ({title}) => {
  return (
    <div className='mt-6 flex flex-row items-center'>
      <Icon alt='' icon='warning' size='small' className='text-yellow-400' />
      <p className='text ml-1 text-sm text-white'>{title}</p>
    </div>
  );
};

WarningLabel.propTypes = {
  title: PropTypes.string.isRequired
};

export default React.memo(WarningLabel);
